import type { OrderStrategyEnum } from "@bbj-types/offer/enum";
import type { ObjectId } from "@bbj-types/utils";
import type { IDateRange } from "@styleguide";
import { useCallback } from "react";
import { axios } from "../axios";
import type { ISocialOfferWithFavoriteChallenges } from "./types";

export interface IUseSearchSocialOffers {
  data: ISocialOfferWithFavoriteChallenges[];
  total_limit: number;
  offers_limit: number;
  skip: number;
  total: number;
  count: number;
  orderStrategy: {
    strategy: string;
  };
  metadata: {
    filtersHash: string;
  };
}

export interface IUseSearchSocialOffersOrderStrategy {
  strategy: OrderStrategyEnum;
}

// TODO: Once the full tags feature is avaiable
// clean this interface removing challenges
// and fully replace it with tags
export interface IUseSearchSocialOffersFilters {
  totalLimit: number;
  offersLimit: number;
  skip?: number;
  tags?: string[];
  challenges?: string[];
  provider?: string;
  query?: string;
  contact?: string[];
  favorite?: boolean;
  places?: ObjectId[];
  searchRadius?: number;
  sources?: string[];
  serviceStartDate?: IDateRange;
  serviceEndDate?: IDateRange;
  orderStrategy?: IUseSearchSocialOffersOrderStrategy;
  contain?: string;
  notContain?: string;
  isRemote?: boolean;
}

export const useSearchSocialOffers = () => {
  const [state, execute, cancel] = axios<IUseSearchSocialOffers, IUseSearchSocialOffersFilters, unknown>(
    {
      url: "/v2/offers/search",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId, data: IUseSearchSocialOffersFilters) => {
      return execute({
        url: `/v2/offers/search/social/candidate/${candidateId}`,
        data,
      });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
